import { Component, ElementRef, HostListener, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { VersionsHistoryService } from '@service/versions-history.service';
import { PublishedVersion } from 'icreate/common/models/versions-history';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-download-version-dialog',
    templateUrl: './download-version-dialog.component.html',
    styleUrl: './download-version-dialog.component.css',
    standalone: false,
})
export class DownloadVersionDialogComponent {
    @ViewChild('listInput') listInput: ElementRef;
    @ViewChild('listContainer') listContainer: ElementRef;

    versionName: string;
    versionsList: PublishedVersion[] = [];

    isLoading: boolean = false;

    showList: boolean = false;
    selectedVersion: PublishedVersion;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            vessel: Vessel;
            shipyardIApi: string;
        },
        private dialogRef: MatDialogRef<DownloadVersionDialogComponent>,
        private versionHistoryService: VersionsHistoryService,
        private translate: TranslateService
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.showList &&
            !this.listContainer?.nativeElement.contains(event.target) &&
            !this.listInput?.nativeElement.contains(event.target)
        ) {
            this.showList = !this.showList;
        }
    }

    async ngOnInit() {
        const shipyardId = this.data.shipyardIApi;
        const vesselId = this.data.vessel.iAPIVesselId;
        this.versionsList.push({
            name: this.data.vessel.projectVersion,
            publishedDate: null,
        });
        this.versionsList = await this.versionHistoryService.getVersionsList(shipyardId, vesselId);
        if (this.data.vessel.projectStatus == ProjectStatus.Editing) {
            this.versionsList.unshift({
                name: this.data.vessel.projectVersion,
                publishedDate: null,
            });
        }
        this.selectedVersion = this.versionsList[0];
    }

    handleVersionSelected(version: PublishedVersion) {
        this.selectedVersion = version;
        this.showList = false;
    }

    close() {
        this.dialogRef.close();
    }

    selectVersion() {
        this.dialogRef.close(this.selectedVersion.name);
    }

    openList() {
        this.showList = !this.showList;
    }

    isCurrentVersion(versionName) {
        return this.data.vessel.projectVersion == versionName;
    }

    get displayedVersion() {
        if (!this.selectedVersion) return;
        if (this.data.vessel.projectVersion == this.selectedVersion.name) {
            return this.translate.instant('dlg.current-version', {
                version: this.selectedVersion.name,
            });
        } else
            return this.translate.instant('dlg.version', {
                version: this.selectedVersion.name,
            });
    }
}
